<template>
    <div>
        <div class="wrapper">
            <div class="col12 pt-0">
                <h1 class="page_title">まもりこサービス対応機器「人感センサー」購入のお申し込み</h1>
                <div class="signup_flow">
                    <ol>
                        <li><span>1</span>ログ <br class="on-sp" />イン</li>
                        <li class="current"><span>2</span>申込 <br class="on-sp" />内容</li>
                        <li><span>3</span>情報 <br class="on-sp" />入力</li>
                        <li><span>4</span>支払</li>
                        <li><span>5</span>完了</li>
                    </ol>
                </div>
                <!-- signup_flow -->
            </div>
        </div>
        <!-- wrapper -->

        <section class="container">
            <div class="wrapper">
                <!-- wrap_pr_2col input_area -->
                <h2 class="col5 section_title">
                    <strong> クーポンコードの入力 </strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <p>クーポンコードをお持ちの場合は入力してください。</p>
                    <div v-if="!isCode1Applied">
                        <div class="col9 col12-sp no_padding">
                            <input type="text" id="code1" v-model="code.code1" />
                        </div>
                        <div class="col3 col12-sp">
                            <a class="btn_round_s white cursor-pointer" @click="promotionCodeApply('code1')">適用</a>
                        </div>
                    </div>
                    <div v-if="isCode1Applied">
                        <div class="col9 col12-sp no_padding">
                            <input type="text" id="code1" v-model="code1DisplayName" readonly="readonly" class="strong" />
                        </div>
                        <div class="col3 col12-sp">
                            <a class="btn_round_s white cursor-pointer" @click="promotionCodeClear()">取消</a>
                        </div>
                    </div>
                    <hr class="thick" />
                </div>
                <!-- wrap_pr_2col input_area -->
                <h2 class="col5 section_title">
                    <strong> お支払い金額 </strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <h3 class="strong big-16 mb-05em">初期費用</h3>
                    <ul class="default_list local">
                        <li>
                            <span>価格</span>
                            <span>&yen;{{ formatCommafy((product.init && product.init.plans[0].amount) || 0) }}</span>
                        </li>
                        <li>
                            <span class="under_line">クーポン利用</span>
                            <span class="under_line">
                                <div v-if="discountInit > 0">&yen;-{{ formatCommafy(discountInit) }}</div>
                                <div v-else>-</div>
                            </span>
                        </li>
                        <li>
                            <span>合計</span>
                            <span>&yen;{{ discountedAmount() }}-(税込)</span>
                        </li>
                    </ul>
                    <p class="submit_btn">
                        <input type="submit" @click="next" value="次へ" onsubmit="return false;" />
                    </p>
                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="cancel">キャンセル</a>
                    </p>
                </div>
                <!-- wrap_pr_2col input_area -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
    </div>
</template>

<script>
export default {
    beforeRouteEnter(to, from, next) {
        // 特定の画面以外からの遷移は禁止
        if (!from.name) {
            // メール記載のURLからの遷移の場合
            if (!document.token) {
                next("/login");
                return;
            }
        } else {
            if (from.name !== "Login" && from.name !== "ContractConfirm" && !document.isWithoutLogin) {
                next("/login");
                return;
            }
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        // 「入力内容を修正」ボタンや、ブラウザで戻られた場合に、入力項目を復元する
        to.params.customerEmail = this.customerEmail;
        to.params.customerName = this.customerName;
        to.params.customerKana = this.customerKana;
        to.params.customerPostalCode = this.customerPostalCode;
        to.params.customerPrefecture = this.customerPrefecture;
        to.params.customerCity = this.customerCity;
        to.params.customerAddress = this.customerAddress;
        to.params.customerTel = this.customerTel;
        to.params.copyAddress = this.copyAddress;
        to.params.destinationName = this.destinationName;
        to.params.destinationKana = this.destinationKana;
        to.params.destinationPostalCode = this.destinationPostalCode;
        to.params.destinationPrefecture = this.destinationPrefecture;
        to.params.destinationCity = this.destinationCity;
        to.params.destinationAddress = this.destinationAddress;
        to.params.destinationTel = this.destinationTel;
        to.params.searchedCustomerPostalCode = this.searchedCustomerPostalCode;
        to.params.searchedDestinationPostalCode = this.searchedDestinationPostalCode;
        to.params.searchedCustomerAddressInfoEmpty = this.searchedCustomerAddressInfoEmpty;
        to.params.searchedDestinationAddressInfoEmpty = this.searchedDestinationAddressInfoEmpty;
        to.params.copiedStripePostalCode = this.copiedStripePostalCode;
        to.params.product = this.product;
        to.params.cards = this.cards;
        to.params.card = this.card;
        to.params.ownerGender = this.ownerGender;
        to.params.ownerAgeGroup = this.ownerAgeGroup;

        to.params.code = this.code;
        to.params.promotionCode = this.promotionCode;

        to.params.isRequiredCredit = this.isRequiredCredit;
        next();
    },
    methods: {
        formatCommafy: function (val) {
            return this.$utils.commafy(val);
        },
        promotionCodeApply: function (id) {
            // 適用を押下した段のクーポンコードが指定されていない場合
            if (!this.code[id]) {
                const errorMessage = this.$errorMessages["MamolicoStorePromotionCodeUnspecifiedException"];
                this.$emit("openAlertModal", errorMessage);
                return;
            }
            this.$emit("showSpinner", "処理中です");
            this.$axios(
                "GET",
                "/couponForm/promotionCode",
                {
                    code: this.code[id],
                    productId: document.productId
                },
                (res) => {
                    // eslint-disable-line
                    this.$emit("hideSpinner");
                    if (res.data && res.data.promotionCode) {
                        // 機器購入用の商品の場合
                        if (this.promotionCode.init) {
                            // 既に機器購入用の商品のプロモーションコードが適用されている場合、エラーにする
                            this.$emit("openAlertModal", "すでにクーポンコードが適用されています");
                            return;
                        }
                        this.promotionCode.init = res.data.promotionCode;
                        // 機器購入用のプロモーションコードは上段であることのフラグを設定
                        this.promotionCode.init.disp1 = true;
                        this.isCode1Applied = true;
                        this.code1DisplayName = this.promotionCode.init.displayName;
                        // 割引額の計算(小数第一位を四捨五入)
                        if (this.promotionCode.init.percentOff) {
                            this.discountInit = Math.round((this.product.init.plans[0].amount * this.promotionCode.init.percentOff) / 100);
                        } else if (this.promotionCode.init.amountOff) {
                            this.discountInit = this.promotionCode.init.amountOff;
                        }
                    }
                }
            );
        },
        promotionCodeClear: function () {
            // 上段の取消が押されたとき
            this.code1 = "";
            if (this.promotionCode.init && this.promotionCode.init.disp1) {
                // 機器購入用の商品のプロモーションコード、割引額をクリア
                this.promotionCode.init = null;
                this.discountInit = 0;
            }
            // クーポンコード上段の適用済フラグと適用表示名を初期化
            this.isCode1Applied = false;
            this.code1DisplayName = "";
        },
        cancel: function () {
            // TOP画面へ遷移
            this.$router.push({
                name: "Top",
                params: {}
            });
        },
        discountedAmount: function () {
            return this.formatCommafy(((this.product.init && this.product.init.plans[0].amount) || 0) - this.discountInit);
        },
        next: function () {
            // クーポンコードチェック(必須項目ではないため、入力されていて未適用の場合)
            if (this.code.code1 && !this.isCode1Applied) {
                this.$emit("openAlertModal", "クーポンコードが適用されていません。");
                return;
            }

            // 合計金額が0でない場合はクレジットカードの入力必須
            const discountedAmount = Number(this.discountedAmount());
            this.isRequiredCredit = discountedAmount !== 0;

            // 顧客情報設定
            this.$emit("showSpinner", "処理中です。");
            if (document.isWithoutLogin) {
                this.$emit("hideSpinner");

                // アカウントなしユーザはAPIを実行しない
                this.$router.push({
                    name: "ContractForm"
                });
                return;
            }

            this.$axios("POST", "/couponForm/next", {}, (res) => {
                this.$emit("hideSpinner");

                if (!this.customerPostalCode && res.data.customer.postalCode) {
                    // Stripe情報を取り出した時だけ郵便番号検索が不要になるようにフラグを設定(クーポンから情報入力画面に遷移するときのみ)
                    this.copiedStripePostalCode = true;
                }

                // 会員情報 ※「戻る」で戻ってきたときに元の内容を反映させるため、持っている情報を優先する
                this.customerEmail = res.data.customer.email || res.data.email || this.customerEmail;
                this.customerName = this.customerName || res.data.customer.name;
                this.customerKana = this.customerKana || res.data.customer.kana;
                this.customerPostalCode = this.customerPostalCode || res.data.customer.postalCode;
                this.customerPrefecture = this.customerPrefecture || res.data.customer.prefecture;
                this.customerCity = this.customerCity || res.data.customer.city;
                this.customerAddress = this.customerAddress || res.data.customer.address;
                this.customerTel = this.customerTel || res.data.customer.tel;
                this.cards = this.cards || res.data.customer.cards;
                // 入力画面へ遷移
                this.$router.push({
                    name: "ContractForm"
                });
            });
        }
    },
    data: function () {
        return {
            paramData: {},
            product: {}, // product: {init: {機器購入用の商品オブジェクト}}
            code: {}, // code: {code1: "上段のプロモーションコード", code2: "下段のプロモーションコード"}
            promotionCode: {}, // promotionCode: {init: {機器購入用のプロモーションコードオブジェクト}}
            isCode1Applied: false, // 上段のプロモーションコードが適用済みかどうかのフラグ
            code1DisplayName: "", // 上段のプロモーションコードが適用済みのときに表示するテキスト
            discountInit: 0, // 機器購入用のプロモーションコード適用による割引額
            searchedCustomerAddressInfoEmpty: false,
            searchedDestinationAddressInfoEmpty: false,
            isRequiredCredit: true // クレジットカードが必須かどうかのフラグ
        };
    },
    created() {
        this.isRequiredCredit = true;
        // 商品情報を持っていない場合 (初回読み込み時)
        if (!this.$route.params || !this.$route.params.product) {
            this.$emit("showSpinner", "処理中です");
            this.$axios(
                "GET",
                "/couponForm/product",
                {
                    productId: document.productId
                },
                (res) => {
                    // eslint-disable-line
                    this.$emit("hideSpinner");
                    if (res.data && res.data.product) {
                        this.paramData.product = res.data.product;
                        this.product = this.paramData.product;
                    }
                }
            );
        }
        // 商品情報を持っている場合 (「入力内容を修正」ボタンや、ブラウザで戻られた場合)
        else {
            // サービス料金
            this.paramData = this.$route.params;
            this.product = this.$route.params.product;
            this.code = this.$route.params.code;
            this.promotionCode = this.$route.params.promotionCode;

            //  会員情報
            this.customerEmail = this.$route.params.customerEmail;
            this.customerName = this.$route.params.customerName;
            this.customerKana = this.$route.params.customerKana;
            this.customerPostalCode = this.$route.params.customerPostalCode;
            this.customerPrefecture = this.$route.params.customerPrefecture;
            this.customerCity = this.$route.params.customerCity;
            this.customerAddress = this.$route.params.customerAddress;
            this.customerTel = this.$route.params.customerTel;
            this.copyAddress = this.$route.params.copyAddress;
            this.cards = this.$route.params.cards;
            this.card = this.$route.params.card;

            // 配送先
            this.destinationName = this.$route.params.destinationName;
            this.destinationKana = this.$route.params.destinationKana;
            this.destinationPostalCode = this.$route.params.destinationPostalCode;
            this.destinationPrefecture = this.$route.params.destinationPrefecture;
            this.destinationCity = this.$route.params.destinationCity;
            this.destinationAddress = this.$route.params.destinationAddress;
            this.destinationTel = this.$route.params.destinationTel;

            this.searchedCustomerPostalCode = this.$route.params.searchedCustomerPostalCode;
            this.searchedDestinationPostalCode = this.$route.params.searchedDestinationPostalCode;

            this.searchedCustomerAddressInfoEmpty = this.$route.params.searchedCustomerAddressInfoEmpty;
            this.searchedDestinationAddressInfoEmpty = this.$route.params.searchedDestinationAddressInfoEmpty;

            // クーポンコードの適用済フラグと適用表示名を設定
            if (this.promotionCode.init && this.promotionCode.init.disp1) {
                this.isCode1Applied = true;
                this.code1DisplayName = this.promotionCode.init.displayName;
            }

            // 割引額の計算(小数第一位を四捨五入)
            if (this.promotionCode.init && this.promotionCode.init.percentOff) {
                this.discountInit = Math.round((this.product.init.plans[0].amount * this.promotionCode.init.percentOff) / 100);
            } else if (this.promotionCode.init && this.promotionCode.init.amountOff) {
                this.discountInit = this.promotionCode.init.amountOff;
            }
        }
    }
};
</script>

<style scoped>
.default_list.local li > span:first-child {
    font-weight: normal;
}
.default_list.local li:first-child > span {
    border-top: none;
}
.default_list.local li > span {
    border-bottom: none;
}
.default_list.local li > span.under_line {
    border-bottom: 1px solid #e6e6e6;
}
.no_padding {
    padding: 0px;
}
</style>
